import { useCallback } from "react";

export type ArrowButtonProps = {
  ariaLabel?: string;
  scrollContainerRef: React.RefObject<HTMLDivElement | null>;
};

export const ArrowButton = ({
  ariaLabel,
  scrollContainerRef,
}: ArrowButtonProps) => {
  const handleScrollRight = useCallback(() => {
    const container = scrollContainerRef.current;
    if (!container) return;
    const scrollAmount = Math.min(container.clientWidth, 300);
    container.scrollBy({ left: scrollAmount, behavior: "smooth" });
  }, []);
  return (
    <button
      type="button"
      onClick={handleScrollRight}
      aria-label={ariaLabel ?? "Next"}
      className="flex justify-center items-center gap-1 px-4 py-4 rounded-[70px] border border-[#3B3B3B]/40 bg-[#3B3B3B] active:scale-[0.98] transition"
    >
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.80474 4.02827C9.54439 3.76792 9.12228 3.76792 8.86193 4.02827C8.60158 4.28862 8.60158 4.71073 8.86193 4.97108L11.7239 7.83301H2.66667C2.29848 7.83301 2 8.13148 2 8.49967C2 8.86786 2.29848 9.16634 2.66667 9.16634H11.7239L8.86193 12.0283C8.60158 12.2886 8.60158 12.7107 8.86193 12.9711C9.12228 13.2314 9.54439 13.2314 9.80474 12.9711L13.8047 8.97108C14.0651 8.71073 14.0651 8.28862 13.8047 8.02827L9.80474 4.02827Z"
          fill="white"
        />
      </svg>
    </button>
  );
};
